/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell } from 'react-table';
import { addMinutes } from 'date-fns';

import { dateToTime } from '@trqk/utils';

interface Props<D extends object> {
    cell: Cell<D>;
}

/**
 * Displays a date and time like: "5/12/2020 01:36:57 PM". The date and time are adjusted for the
 * timezone offset so that they display in UTC.
 * @param Props must contain a `cell.value` which is either a string or number that can be used to
 * instantiate a JavaScript Date. Usually this will be an AWSDateTime, which is an ISO8601 date
 * string.
 */
export function DateTimeCell<D extends object>({
    cell,
}: Props<D>): JSX.Element {
    const { value } = cell;

    if (value === null) {
        return <div>None</div>;
    }

    const date = new Date(value);
    const timezoneOffset = date.getTimezoneOffset();
    const dateWithOffset = addMinutes(date, timezoneOffset);
    const dateString = new Intl.DateTimeFormat('en', {
        calendar: 'gregory',
    }).format(dateWithOffset);
    const timeString = dateToTime(dateWithOffset);

    return <div>{`${dateString} ${timeString}`}</div>;
}
